"use client";

import useEvents from "@app/_hooks/useEvents";
import Link from "@components/Link";
import type { ReactNode } from "react";
import { forwardRef, useCallback, useContext } from "react";
import { cn } from "@/lib/utils";
import { ProductCardContext } from "./ProductCardContext";

type ProductCardLinkProps = {
  className?: string;
  children?: ReactNode;
};

const ProductCardLink = forwardRef<HTMLAnchorElement, ProductCardLinkProps>(
  ({ className, children, ...props }, ref) => {
    const { clickItem } = useEvents();
    const { product, locale, marketConfig } = useContext(ProductCardContext);

    const trackSelectListItemEvent = useCallback(() => {
      if (
        clickItem === undefined ||
        product === undefined ||
        marketConfig?.currency === undefined
      ) {
        return;
      }

      clickItem(product);
    }, [marketConfig?.currency, product, clickItem]);

    if (!product) return null;

    return (
      <Link
        ref={ref}
        locale={locale}
        href={product.ProductURL ?? ""}
        className={cn("block bg-white", className)}
        onClick={() => {
          trackSelectListItemEvent();
        }}
        customPrefetch="onMouseEnter"
        {...props}
      >
        {children}
      </Link>
    );
  },
);

ProductCardLink.displayName = "ProductCardLink";

export default ProductCardLink;
